import FooterHandleStatus from "pages/EstimateViewer/components/Footer/FooterHandleStatus";

const GeneralEstmViewerFooterSettings = ({ treeWidth, projectMeta, userPermissions, userSettings }) => {
	return [
		{
			type: "common",
			text: null,
			icon: null,
			position: "left",
			callback: () => {},
			style: { width: treeWidth, minWidth: treeWidth },
			jsx: <FooterHandleStatus meta={projectMeta} />,
			isVisible: userPermissions?.is_expert === true && userSettings?.projectTree?.lsrStatusUsage === true,
		},
	];
};

export default GeneralEstmViewerFooterSettings;
